<template>
  <el-card>
    <div slot="header" class="clearfix">
      <span>支付流程统计</span>
    </div>

    <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
      <el-form-item label="日期" prop="endDate">
        <el-date-picker
          v-model="queryParams.startDate"
          type="date"
          size="mini"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="日期" prop="endDate">
        <el-date-picker
          v-model="queryParams.endDate"
          type="date"
          size="mini"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" :loading="loading" icon="el-icon-search" @click="handleQuery">查询</el-button>
        <!--        <el-button type="success" size="mini" :loading="loading" icon="el-icon-search" @click="exportData">导出</el-button>-->
      </el-form-item>
    </el-form>

    <el-table
      border
      :data="tableData"
      :default-expand-all="false"
      row-key="date"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      style="width: 100%;margin-bottom: 20px;"
    >

      <el-table-column
        prop="date"
        label="日期"
        align="center"
      />
      <el-table-column
        prop="create_order"
        label="创建订单"
        align="center"
      />
      <el-table-column
        label="调起支付"
        align="center"
      >
        <el-table-column
          prop="order_pay"
          label="次数"
          align="center"
        />
        <el-table-column
          label="成功率"
          align="center"
        >
          <template slot="header">
            <el-popover
              placement="top-start"
              width="320"
              trigger="hover"
              content="成功率=调起支付/创建订单"
            >
              <span slot="reference">成功率 <i class="el-icon-warning-outline" /></span>
            </el-popover>
          </template>
          <template scope="scope">
            <span>{{ scope.row.order_pay_rate }}%</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="支付成功"
        align="center"
      >
        <el-table-column
          prop="pay_status"
          label="次数"
          align="center"
        />
        <el-table-column
          label="成功率"
          align="center"
        >
          <template slot="header">
            <el-popover
              placement="top-start"
              width="320"
              trigger="hover"
              content="成功率=支付成功/调起支付"
            >
              <span slot="reference">成功率 <i class="el-icon-warning-outline" /></span>
            </el-popover>
          </template>
          <template scope="scope">
            <span>{{ scope.row.pay_status_rate }}%</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="请求发货"
        align="center"
      >
        <el-table-column
          prop="order_ship"
          label="次数"
          align="center"
        />
        <el-table-column
          label="成功率"
          align="center"
        >
          <template slot="header">
            <el-popover
              placement="top-start"
              width="320"
              trigger="hover"
              content="成功率=请求发货/支付成功"
            >
              <span slot="reference">成功率 <i class="el-icon-warning-outline" /></span>
            </el-popover>
          </template>
          <template scope="scope">
            <span>{{ scope.row.order_ship_rate }}%</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="发货成功"
        align="center"
      >
        <el-table-column
          prop="order_ship_status"
          label="次数"
          align="center"
        />
        <el-table-column
          label="成功率"
          align="center"
        >
          <template slot="header">
            <el-popover
              placement="top-start"
              width="320"
              trigger="hover"
              content="成功率=发货成功/请求发货"
            >
              <span slot="reference">成功率 <i class="el-icon-warning-outline" /></span>
            </el-popover>
          </template>
          <template scope="scope">
            <span>{{ scope.row.order_ship_staus_rate }}%</span>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>

    <totalStat ref="payProcess" title="支付流程" />
    <totalStat ref="payFail" title="支付失败原因" />
    <totalStat ref="shipFail" title="请求发货失败原因" />
  </el-card>
</template>

<script>
import { getCooperativeBuildStat, getPayProcessStat } from '@/api/statistics/user_remain'
import { getCacheQuery, getLastDates, setCacheQuery } from '@/utils'
import totalStat from '@/views/config/pay-order-stat/components/echart.vue'

export default {
  name: 'PayProcessStat',
  components: {
    totalStat
  },
  data() {
    return {
      loading: false,
      queryParams: {
        startDate: '',
        endDate: '',
        type: 0
      },
      typeArr: [{ label: '天', value: 0 }, { label: '总', value: 1 }],
      tableData: []
    }
  },
  created() {
    this.queryParams.startDate = getLastDates(7)
    this.queryParams.endDate = getLastDates(0)
    this.getTables(undefined)
  },
  methods: {
    handleQuery() {
      if (!this.queryParams.startDate) {
        this.msgError('请选择开始日期')
        return
      }
      if (!this.queryParams.endDate) {
        this.msgError('请选择开始日期')
        return
      }
      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }
      this.loading = true
      this.getTables({})
    },
    getTables(event) {
      this.queryParams.level = 0
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      getPayProcessStat(this.queryParams).then(res => {
        setCacheQuery(this.$options.name, this.queryParams)
        this.loading = false
        this.tableData = res.data.data
        this.$refs.payProcess.refresh(this.tableData)
        this.$refs.payFail.payFail(this.tableData, 'order_status_distribution')
        this.$refs.shipFail.payFail(this.tableData, 'corder_ship_status_distribution')
      })
    },
    exportData() {
      this.queryParams.level = 1
      getCooperativeBuildStat(this.queryParams).then(res => {
        window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
      })
    }
  }

}
</script>

<style scoped>
.mtop{
  margin-top: 20px;
}
</style>
